import React, { useState } from "react";
import { SOCIAL_LINKS } from "../data/socials";
import {
  IoChatbubblesOutline,
  IoCopyOutline,
  IoCheckmarkOutline,
  IoOpenOutline,
} from "react-icons/io5";

export default function Contact() {
  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopiedId(id);
    setTimeout(() => {
      setCopiedId(null);
    }, 2000);
  };

  return (
    <article className="animate-fade-in" data-page="contact">
      <header className="mb-6">
        <h2 className="text-3xl font-bold font-display text-white">Contact</h2>
        <div className="w-12 h-1 bg-gradient-to-r from-violet-500 to-indigo-500 rounded-full mt-2"></div>
      </header>

      <section className="space-y-6">
        {/* DM Notice Banner */}
        <div className="relative overflow-hidden p-6 sm:p-8 rounded-2xl bg-gradient-to-br from-violet-900/20 via-zinc-900/40 to-zinc-900/60 border border-violet-500/20 shadow-xl backdrop-blur-sm">
          <div className="absolute -top-12 -right-12 w-40 h-40 bg-violet-500/10 rounded-full blur-3xl pointer-events-none"></div>
          
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 relative z-10">
            <div className="w-12 h-12 rounded-xl bg-violet-500/15 border border-violet-500/30 flex items-center justify-center text-violet-400 shrink-0">
              <IoChatbubblesOutline className="text-2xl" />
            </div>
            <div>
              <h3 className="text-lg font-semibold font-display text-white">
                Send a Direct Message (DM)
              </h3>
              <p className="text-sm text-zinc-400 mt-1 leading-relaxed font-sans">
                The best and fastest way to get in touch with me is by sending a DM on any of my social profiles or dropping an email. I usually respond within a few hours!
              </p>
            </div>
          </div>
        </div>

        {/* Social Links Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 pt-2">
          {SOCIAL_LINKS.map((item) => {
            const IconComponent = item.icon;
            const isCopied = copiedId === item.id;

            return (
              <div
                key={item.id}
                className={`group relative flex flex-col justify-between p-6 rounded-2xl bg-zinc-900/30 border border-zinc-800/80 ${item.borderColor} transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/40 overflow-hidden`}
              >
                {/* Subtle card background accent */}
                <div
                  className={`absolute inset-0 bg-gradient-to-br ${item.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none`}
                ></div>

                <div className="relative z-10">
                  {/* Card Header */}
                  <div className="flex items-center justify-between gap-3 mb-3">
                    <div className="flex items-center gap-3">
                      <div
                        className={`w-10 h-10 rounded-xl bg-zinc-900 border border-zinc-800 flex items-center justify-center ${item.iconColor} group-hover:scale-105 transition-transform duration-300`}
                      >
                        <IconComponent className="text-xl" />
                      </div>
                      <div>
                        <h4 className="text-base font-semibold text-white font-display">
                          {item.name}
                        </h4>
                        <p className="text-xs text-zinc-400 font-mono">
                          {item.username}
                        </p>
                      </div>
                    </div>

                    <span className="text-[11px] font-medium px-2.5 py-0.5 rounded-full bg-zinc-800/80 text-zinc-400 border border-zinc-700/50">
                      {item.badgeText}
                    </span>
                  </div>

                  <p className="text-xs text-zinc-400 font-sans leading-relaxed my-3">
                    {item.description}
                  </p>
                </div>

                {/* Actions */}
                <div className="relative z-10 flex items-center gap-2 pt-4 mt-auto border-t border-zinc-800/50">
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noreferrer"
                    className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-xs font-semibold text-white ${item.btnBg} transition-all cursor-pointer`}
                  >
                    <span>{item.actionText}</span>
                    <IoOpenOutline className="text-sm" />
                  </a>

                  <button
                    onClick={() => handleCopy(item.url.startsWith("mailto:") ? item.handle : item.url, item.id)}
                    className="p-2.5 rounded-xl bg-zinc-900 hover:bg-zinc-800 border border-zinc-800 text-zinc-400 hover:text-white transition-colors cursor-pointer"
                    title={`Copy ${item.name} ${item.url.startsWith("mailto:") ? "email" : "link"}`}
                  >
                    {isCopied ? (
                      <IoCheckmarkOutline className="text-emerald-400 text-base" />
                    ) : (
                      <IoCopyOutline className="text-base" />
                    )}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </article>
  );
}

